import Api from './Api'

class ProductService {
    static getAll () {
        return Api().get('/product');
    }  
    static get (id) {
        return Api().get(`/product/${id}`);
    }  
}

export default ProductService;